import Action from "@/action/Action"
import DelegatingInitFlowAction from "@/action/actions/DelegatingInitFlowAction"

class BaseStartFlowAction extends Action {

    route = null

    constructor(actionId, route) {
        super(actionId)
        this.route = route
    }

    async invoke() {
        const response = await this.callStartFlowService()
        return new DelegatingInitFlowAction(this.route, response).invoke()
    }

    async callStartFlowService() {
        throw new Error("Not Implemented")
    }
}

export default BaseStartFlowAction
